function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "../Button/Button";
import ButtonIcon from "../Button/ButtonIcon";
const sizeMap = {
  small: "1rem",
  medium: "2rem",
  large: "3rem",
  huge: "5rem"
};
export default class IconButton extends Component {
  render() {
    const {
      name,
      size,
      buttonStyle,
      iconColor,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
      shape: "circle",
      size: size,
      variant: buttonStyle
    }), /*#__PURE__*/React.createElement(ButtonIcon, {
      color: iconColor,
      name: name,
      size: sizeMap[size]
    }));
  }

}

_defineProperty(IconButton, "defaultProps", {
  size: "medium",
  buttonStyle: "secondary"
});